import React from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/new-search-widget.module.scss";
import {NewSearchWidgetEntitiesSection} from "./entities/new-search-widget.entities.section";
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import {NewSearchWidgetRecentKeyboardClickComposer} from "../composers/new-search-widget.recent-keyboard-click.composer";

export const NewSearchWidgetRecentSearches = NewSearchWidgetRecentKeyboardClickComposer(observer(({controller, highlightedItemIndex, setHighlightedItemIndex}) => {
  const {state} = controller;
  const {recentSearchListModel, hasRecentSearchesItems, shouldRenderRecentSearches, isRecentSearchedHighlighted} = state;

  const containerProps = {
    className: classNames(styles.recent_searches,{[styles.tab_section]: isRecentSearchedHighlighted}),
    onMouseEnter: () => controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick, {index: NEW_SEARCH_WIDGET.TAB_SECTION.recentSearches})
  }

  const recentListModelProps = {
    controller,
    listModel: recentSearchListModel,
    highlightedItemIndex,
    hasRecentSearchesItems,
    onMouseEnter: (index) => setHighlightedItemIndex(index),
    isRecentSearchesList: true
  }

  return shouldRenderRecentSearches ? <div {...containerProps}>
    <NewSearchWidgetEntitiesSection {...recentListModelProps}/>
  </div> : null
}));
